import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Label, Card, CardBody } from "reactstrap";
import { Btn, H4 } from "../../../AbstractElements";
import { useForm } from "react-hook-form";
import * as queries from "../../../graphql/queries";
import * as mutations from "../../../graphql/mutations";
import { toast } from "react-toastify";
import { useNavigate, useLocation, useParams, Link } from "react-router-dom";
import Autocomplete from "react-google-autocomplete";
import SiteDBData from "../../../Data/DistributionBoard/index";
import SiteData from "../../../Data/Sites/index";
import { limit } from "../../../Config/Config";
import { generateClient } from "aws-amplify/api";

const client = generateClient({
  headers: {
    "x-api-key": "da2-ox6gomta4baghjuzk6hpogw25y",
  },
});
var base64 = require("base-64");

const AddEditSiteDetails = () => {
  const navigate = useNavigate();
  const state = useLocation();
  const { view } = useParams();

  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm();

  // --- state
  const [companyDetails, setCompanyDetails] = useState([]);
  const [assetOwner, setAssetOwner] = useState([]);
  const [assetOwnerFilter, setAssetOwnerFilter] = useState([]);
  const [siteAddressArray, setSiteAddressArray] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [siteDetail, setSiteDetail] = useState(null);
  const [distributionDetails, setDistributionDetails] = useState([]);
  const [address, setAddress] = useState("");
  const [assetOwnerIds, setAssetOwnerId] = useState("");
  const LoginUserDetails = JSON.parse(localStorage.getItem("userDetails"));
  const LoginUserGroup = localStorage.getItem("groups");
  const [siteLimit, setSiteLimit] = useState(0);
  const [siteLimitCountOftheAO, setSiteLimitCountOftheAO] = useState(0);
  const [AOSite, setAOSite] = useState([]);
  const [sitedupdata, setSitedupdata] = useState([]);
  const [edit, setEdit] = useState(false);
  const [sitesdup, setSitesDup] = useState(false);
  const [sitesdupdetails, setSitesDupDetails] = useState(false);
  const [catId, setCatId] = useState();
  const [maxNum, setMaxNum] = useState();

  // --- small helpers to avoid duplication
  const gql = async ({ query, variables = {}, authMode = "API_KEY" }) =>
    client.graphql({ query, variables, authMode });

  const decodeLocal = (key) => {
    const v = localStorage.getItem(key);
    return v ? JSON.parse(base64.decode(v)) : null;
  };
  const encodeLocal = (key, data) =>
    localStorage.setItem(key, base64.encode(JSON.stringify(data)));

  // --- fetch companies + asset owners (admin flow)
  async function fetchCompanies() {
    const result = await gql({
      query: queries.listCompanyDetails,
      variables: { limit },
    });
    if (result?.data?.listCompanyDetails?.items?.length > 0) {
      const companies = result.data.listCompanyDetails.items;
      setCompanyDetails(companies);

      const result1 = await gql({
        query: queries.listAssetOwners,
        variables: { limit },
      });
      if (result1?.data?.listAssetOwners?.items?.length > 0) {
        const assetOwnerDetails = result1.data.listAssetOwners.items;
        setAssetOwner(assetOwnerDetails);
        setAssetOwnerFilter(assetOwnerDetails);

        if (state.state?.page === "assetOwner") {
          reset({
            companyName: state.state.companyId,
            assetOwner: state.state.assetOwnerId,
          });
        } else {
          // state.state is likely the site id
          fetchEditSiteDetail(state.state);
        }
      }
    }
  }

  // --- fetch a single site and its distribution boxes
  async function fetchEditSiteDetail(siteId) {
    if (!siteId) return;
    const result = await gql({
      query: queries.getSiteDetails,
      variables: { id: siteId },
    });
    const site = result?.data?.getSiteDetails;
    if (site) {
      const dbResult = await gql({
        query: queries.distributionBoxesBySitedetailsID,
        variables: { sitedetailsID: siteId, limit },
      });
      const dBDetails =
        dbResult?.data?.distributionBoxesBySitedetailsID?.items || [];
      setDistributionDetails(dBDetails);
      setSiteDetail(site);
      setEditMode(true);

      const editDetails = {
        companyName: site.companydetailsID,
        assetOwner: site.assetownerID,
        siteAddress: site.unitNumber,
        siteName: site.siteName,
        distributionBox: dBDetails?.length
          ? dBDetails[0].distributionBoxName
          : "",
        location: dBDetails?.length ? dBDetails[0].location : "",
      };

      setAddress(site.unitNumber);
      reset(editDetails);
    }
  }

  // --- main initialization effect (runs once)
  useEffect(() => {
    SerialId();

    if (state.state != null) {
      // when state is present (edit/add-for-AO flows)
      if (LoginUserGroup === "admin") {
        fetchCompanies();
      } else if (LoginUserGroup === "site_user") {
        fetchCompanyDetailsAOSu();
        fetchEditSiteDetail(state.state);
      } else {
        fetchCompanyDetailsAO();
        fetchEditSiteDetail(state.state);
      }
    } else {
      // no state - general create flows
      const fetchCompanyDetails = async () => {
        const dataDetails = await gql({
          query: queries.listCompanyDetails,
          variables: { limit },
        });
        const items = dataDetails?.data?.listCompanyDetails?.items || [];
        if (items.length > 0) {
          // remove deleted & duplicates (keeps first occurrence)
          const filtered = items.filter((it) => !it.deleted);
          const unique = filtered.filter(
            (item, idx, arr) => arr.findIndex((a) => a.id === item.id) === idx
          );
          setCompanyDetails(unique);
        }
      };

      const fetchAssetOwner = async () => {
        const result = await gql({
          query: queries.listAssetOwners,
          variables: { limit },
        });
        const items = result?.data?.listAssetOwners?.items || [];
        if (items.length > 0) {
          setAssetOwner(items);
          setAssetOwnerFilter(items);
        }
      };

      if (LoginUserGroup === "admin") {
        fetchCompanyDetails();
        fetchAssetOwner();
      } else if (LoginUserGroup === "site_user") {
        fetchCompanyDetailsAOSu();
      } else {
        fetchCompanyDetailsAO();
      }
    }

    // site_owner extra data
    if (LoginUserGroup === "site_owner") {
      (async function fetchSubscriptionLimit() {
        const result = await gql({
          query: queries.listSubscriptionLimits,
          variables: {
            filter: { subscriptionId: { eq: LoginUserDetails.paymentId } },
            limit,
          },
        });
        const items = result?.data?.listSubscriptionLimits?.items || [];
        if (items.length > 0) {
          setSiteLimit(items[0].SiteLimit);
        }
      })();

      (async function fetchSiteOfAOLimit() {
        const result = await gql({
          query: queries.siteDetailsByAssetownerID,
          variables: { assetownerID: LoginUserDetails.id, limit },
        });
        const items = result?.data?.siteDetailsByAssetownerID?.items || [];
        if (items.length > 0) {
          setSiteLimitCountOftheAO(items.length);
        }
      })();
    }

    // --- SerialId inner function (compute next distribution box number)
    async function SerialId() {
      const response = await gql({
        query: queries.listDistributionBoxes,
        variables: { limit },
      });
      const boxes = response?.data?.listDistributionBoxes?.items || [];
      if (boxes.length === 0) {
        setCatId("000");
        setMaxNum(1);
        return;
      }

      const idArry = [];
      boxes.forEach((item) => {
        const numPart = item.distributionBoxNumber?.replace(/^\D+/g, "");
        if (!numPart || isNaN(Number(numPart))) {
          idArry.push(1);
        } else {
          idArry.push(Number(numPart));
        }
      });

      const maxnumber = idArry.length ? Math.max(...idArry) : 0;
      const nextNum = maxnumber ? maxnumber + 1 : 1;
      const digits = digits_count(nextNum);

      if (digits === 1) setCatId("000");
      else if (digits === 2) setCatId("00");
      else if (digits === 3) setCatId("0");
      else setCatId("");
      setMaxNum(nextNum);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // --- helper getters (unchanged behavior)
  const getCompanyName = (id) => {
    const company = companyDetails.find((item) => item.id === id);
    return company ? company.companyName : "";
  };

  const getAO = (id) => {
    const ao = assetOwner.find((item) => item.id === id);
    return ao ? `${ao.firstName} ${ao.lastName}` : "";
  };

  const digits_count = (n) => {
    // keep original counting logic but simpler
    if (!n || n < 1) return 0;
    return String(Math.floor(n)).length;
  };

  // --- simplified AO company fetchers (merged behavior preserved)
  async function fetchCompanyDetailsAO() {
    const dataDetails = await gql({
      query: queries.getAssetOwner,
      variables: { id: LoginUserDetails.id, limit },
    });
    const owner = dataDetails?.data?.getAssetOwner;
    if (owner) {
      setCompanyDetails([
        { id: owner.companydetailsID, companyName: owner.companyName },
      ]);
      const ao = [
        {
          id: owner.id,
          firstName: owner.firstName,
          lastName: owner.lastName,
          companydetailsID: owner.companydetailsID,
        },
      ];
      setAssetOwner(ao);
      setAssetOwnerFilter(ao);
    }
  }

  async function fetchCompanyDetailsAOSu() {
    const dataDetails = await gql({
      query: queries.getAssetOwner,
      variables: { id: LoginUserDetails.assetOwnerId, limit },
    });
    const owner = dataDetails?.data?.getAssetOwner;
    if (owner) {
      setCompanyDetails([
        { id: owner.companydetailsID, companyName: owner.companyName },
      ]);
      const ao = [
        {
          id: owner.id,
          firstName: owner.firstName,
          lastName: owner.lastName,
          companydetailsID: owner.companydetailsID,
        },
      ];
      setAssetOwner(ao);
      setAssetOwnerFilter(ao);
    }
  }

  // --- watch companyName changes to filter AO list
  React.useEffect(() => {
    const companyName = watch("companyName");
    if (assetOwnerIds) {
      setAssetOwnerFilter(
        assetOwner.filter((item) => item.companydetailsID === assetOwnerIds)
      );
    } else if (companyName) {
      setAssetOwnerFilter(
        assetOwner.filter((item) => item.companydetailsID === companyName)
      );
    } else {
      setAssetOwnerFilter(assetOwner);
    }
  }, [watch("companyName"), assetOwner, assetOwnerIds]);

  const onCancel = () => {
    navigate(`${process.env.PUBLIC_URL}/sites`);
  };

  // --- PLACE changed -> parse components into address object
  const onPlaceChanged = (detailAddress) => {
    const fullAddress1 = {};
    for (let i = 0; i < detailAddress.length; i++) {
      const comp = detailAddress[i];
      if (comp.types.includes("postal_code"))
        fullAddress1.postCode = comp.long_name;
      if (comp.types.includes("locality")) fullAddress1.suburb = comp.long_name;
      if (comp.types.includes("administrative_area_level_1"))
        fullAddress1.state = comp.long_name;
      if (comp.types.includes("administrative_area_level_2"))
        fullAddress1.street = comp.long_name;
      if (comp.types.includes("country")) fullAddress1.country = comp.long_name;
    }
    setSiteAddressArray(fullAddress1);
  };

  // --- fetch all AO list (used in a small effect)
  async function fetchAONew() {
    const result = await gql({
      query: queries.listAssetOwners,
      variables: { limit },
    });
    const items = result?.data?.listAssetOwners?.items || [];
    if (items.length > 0) setAOSite(items);
  }

  useEffect(() => {
    fetchAONew();
    setEdit(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.state && state.state.page === "assetOwner"]);

  // --- fetch sites for AO with pagination then store locally and fetch DBs
  async function fetchSiteDetailsAO(assetOwnerId) {
    try {
      let nextToken = "";
      let sites = [];
      const first = await gql({
        query: queries.siteDetailsByAssetownerID,
        variables: { assetownerID: assetOwnerId, limit },
      });
      if (first?.data?.siteDetailsByAssetownerID?.items?.length > 0) {
        sites.push(first.data.siteDetailsByAssetownerID.items);
        nextToken = first.data.siteDetailsByAssetownerID.nextToken;
        while (nextToken != null) {
          const page = await gql({
            query: queries.siteDetailsByAssetownerID,
            variables: { assetownerID: assetOwnerId, limit, nextToken },
          });
          const items = page?.data?.siteDetailsByAssetownerID?.items || [];
          if (items.length > 0) {
            sites.push(items);
            nextToken = page.data.siteDetailsByAssetownerID.nextToken;
          } else {
            nextToken = null;
          }
        }
        const mergeSites = sites.flat(1);
        SiteData.setSiteData(mergeSites);
        encodeLocal("site", mergeSites);
        fetchListDistributionBox(mergeSites);
      }
    } catch (error) {
      console.log(error);
    }
  }

  // --- fetch distribution boxes for an array of sites
  async function fetchListDistributionBox(siteData) {
    try {
      const promises = siteData.map((item) =>
        gql({
          query: queries.distributionBoxesBySitedetailsID,
          variables: { sitedetailsID: item.id, limit },
        })
      );
      const results = await Promise.all(promises);
      const SiteDB = [];
      results.forEach((items) => {
        const dbItems =
          items?.data?.distributionBoxesBySitedetailsID?.items || [];
        if (dbItems.length > 0) SiteDB.push(dbItems);
      });
      if (SiteDB.length > 0) {
        const flat = SiteDB.flat(1);
        SiteDBData.setSiteDBData(flat);
        encodeLocal("siteDB", flat);
      }
    } catch (error) {
      console.log(error);
    }
  }

  // --- submit handler (logic preserved; cleaned structure)
  const onSubmit = async (data) => {
    try {
      // CREATE (no state) -> uses local 'site' storage to check duplicates
      if (state.state === null) {
        const siteslist = decodeLocal("site") || [];
        const sitescompfilter = siteslist.filter(
          (item) => item.companydetailsID === data.companyName
        );
        const nameFilter = sitescompfilter.filter(
          (item) => item.siteName === data.siteName
        );
        setSitedupdata(nameFilter);
        if (nameFilter.length > 0) {
          setSitesDup(true);
          return;
        }

        // create site
        const createRes = await gql({
          query: mutations.createSiteDetails,
          variables: {
            input: {
              unitNumber: address,
              siteName: data.siteName,
              companydetailsID: data.companyName,
              assetownerID: data.assetOwner,
              status: "Active",
            },
          },
        }).catch((error) => {
          console.log(error);
          throw error;
        });

        const siteId = createRes.data.createSiteDetails.id;

        // create default logbook (fire-and-forget; keep original then())
        client
          .graphql({
            query: mutations.createLogBook,
            variables: {
              input: {
                siteId,
                sitedetailsID: siteId,
                status: "Active",
                logbookName: data.siteName + " - Default Logbook",
              },
            },
            authMode: "API_KEY",
          })
          .then((r) => console.log(r));

        const addedsite = await gql({
          query: queries.getSiteDetails,
          variables: { id: siteId },
        });

        if (addedsite?.data?.getSiteDetails && decodeLocal("site") !== null) {
          const activeSites = decodeLocal("site") || [];
          activeSites.push(addedsite.data.getSiteDetails);
          encodeLocal("site", activeSites);
        }

        navigate(`${process.env.PUBLIC_URL}/sites`, {
          state: { id: siteId, unitNumber: address, siteName: data.siteName },
        });
        return;
      }

      // CREATE for assetOwner page
      if (state.state?.page === "assetOwner") {
        const createRes = await gql({
          query: mutations.createSiteDetails,
          variables: {
            input: {
              unitNumber: address,
              siteName: data.siteName,
              street: siteAddressArray?.street || "",
              suburb: siteAddressArray?.suburb || "",
              state: siteAddressArray?.state || "",
              postCode: siteAddressArray?.postCode || "",
              country: siteAddressArray?.country || "",
              companydetailsID: data.companyName,
              assetownerID: data.assetOwner,
              status: "Active",
            },
          },
        }).catch((error) => {
          console.log(error);
          throw error;
        });

        const siteId = createRes.data.createSiteDetails.id;
        const addedsite = await gql({
          query: queries.getSiteDetails,
          variables: { id: siteId },
        });
        if (addedsite?.data?.getSiteDetails && decodeLocal("site") !== null) {
          const activeSites = decodeLocal("site") || [];
          activeSites.push(addedsite.data.getSiteDetails);
          encodeLocal("site", activeSites);
        }
        fetchSiteDetailsAO(LoginUserDetails.id);
        navigate(`${process.env.PUBLIC_URL}/sites`, {
          state: {
            id: siteId,
            unitNumber: address,
            siteName: data.siteName,
            page: "ao",
          },
        });
        return;
      }

      // UPDATE existing site
      {
        const result = await gql({
          query: mutations.updateSiteDetails,
          variables: {
            input: {
              id: siteDetail.id,
              unitNumber: address,
              siteName: data.siteName,
              street: siteAddressArray?.street || "",
              suburb: siteAddressArray?.suburb || "",
              state: siteAddressArray?.state || "",
              postCode: siteAddressArray?.postCode || "",
              country: siteAddressArray?.country || "",
              companydetailsID: data.companyName,
              assetownerID: data.assetOwner,
            },
          },
        });

        if (result) {
          const addedsite = await gql({
            query: queries.getSiteDetails,
            variables: { id: siteDetail.id, limit: 10000 },
          });
          if (addedsite?.data?.getSiteDetails) {
            let activeAssets = decodeLocal("site") || [];
            const existingIndex = activeAssets.findIndex(
              (item) => item.id === addedsite.data.getSiteDetails.id
            );
            if (existingIndex > -1)
              activeAssets[existingIndex] = addedsite.data.getSiteDetails;
            else activeAssets.push(addedsite.data.getSiteDetails);
            encodeLocal("site", activeAssets);
          }

          toast.success("Site Detail Updated Successfully", {
            position: toast.POSITION.TOP_CENTER,
          });
          fetchSiteDetailsAO(LoginUserDetails.id);
          navigate(`${process.env.PUBLIC_URL}/sites`);
        } else {
          toast.error("Error On Site Updation: ", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      }
    } catch (e) {
      toast.error("Error On Site Creation: " + (e?.message || e), {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  // --- UI
  return (
    <Fragment>
      <br />
      <Card className="custom-card">
        <CardBody>
          <form
            className="needs-validation"
            noValidate
            onSubmit={handleSubmit(onSubmit)}
            style={{ padding: "10px" }}
          >
            <H4>
              {state.state == null
                ? "Add Site"
                : state.state.page === "assetOwner"
                ? "Add Site For Asset Owner"
                : "Edit Site"}
            </H4>

            {/* {siteLimitCountOftheAO !== 0 &&
            siteLimitCountOftheAO >= siteLimit ? (
              <Row>
                <Col md="12">
                  <div>
                    <p className="errorSubscription">
                      Sorry!.. Your SP Users Limit is Exceeded, Please Upgrade
                      your Subscription
                    </p>
                  </div>
                  <Btn attrBtn={{ color: "warning", onClick: onCancel }}>
                    Close
                  </Btn>
                </Col>
              </Row>
            ) : ( */}
              <>
                <Row>
                  <Col md="6 mb-3">
                    <Label>Company Details</Label>
                    <select
                      className="form-control"
                      name="companyName"
                      {...register("companyName", { required: true })}
                      onChange={(event) => setAssetOwnerId(event.target.value)}
                    >
                      <option value="">Choose Company Name</option>
                      {companyDetails
                        .filter((item) => !item.deleted)
                        .map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.companyName}
                          </option>
                        ))}
                    </select>
                  </Col>
                  <Col md="6 mb-3">
                    <Label>Asset Owner</Label>
                    <select
                      className="form-control"
                      name="assetOwner"
                      {...register("assetOwner", { required: true })}
                    >
                      <option value="">Choose Asset Owner</option>
                      {assetOwnerFilter.map((item) => (
                        <option value={item.id} key={item.id}>
                          {item.firstName} {item.lastName}
                        </option>
                      ))}
                    </select>
                  </Col>
                </Row>

                <Row>
                  <Col md="6 mb-3">
                    <Label>Site Name</Label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Site Name"
                      name="siteName"
                      {...register("siteName", { required: true })}
                    />
                    <span>{errors.siteName && "Please Enter Site Name."}</span>
                  </Col>
                  <Col md="6 mb-3">
                    <Label>Site Address..</Label>
                    <Autocomplete
                      apiKey="AIzaSyBTumeD-l8p-2slpOP7PEJ7KKOlaFfOOj4"
                      className="form-control"
                      onPlaceSelected={(place) => {
                        setAddress(place.formatted_address);
                        const addressComp = place.address_components;
                        onPlaceChanged(addressComp);
                      }}
                      options={{
                        types: ["address"],
                        componentRestrictions: { country: "AU" },
                      }}
                      name="siteAddress"
                      placeholder="Site Address"
                      defaultValue={address}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col className="text-end">
                    <Btn attrBtn={{ color: "primary" }}>
                      {!editMode ? "Save" : "Update"}
                    </Btn>
                    <Btn attrBtn={{ color: "danger", onClick: onCancel }}>
                      Cancel
                    </Btn>
                  </Col>
                </Row>
              </>
             {/* )} */}
          </form>

          {sitesdup && (
            <form className="needs-validation" noValidate>
              <Row>
                <Col sm="9">
                  <p className="errorSubscription">
                    Already site exist with a same SiteName for the selected
                    AssetOwner and Company.
                  </p>
                </Col>
                <Col sm="3">
                  <Link to={`${process.env.PUBLIC_URL}/sites`}>
                    Click here to check the Site Details
                  </Link>
                </Col>
              </Row>

              <Row>
                {sitesdupdetails && sitedupdata?.[0] && (
                  <div className="needs-validation">
                    <Row>
                      <Col sm="4">
                        <Label>Site Name</Label>
                        <p>{sitedupdata[0].siteName}</p>
                      </Col>
                      <Col sm="4">
                        <Label>Asset Owner</Label>
                        <p>{getAO(sitedupdata[0].assetownerID)}</p>
                      </Col>
                      <Col sm="4">
                        <Label>Company Name</Label>
                        <p>{getCompanyName(sitedupdata[0].companydetailsID)}</p>
                      </Col>
                    </Row>
                  </div>
                )}
              </Row>
            </form>
          )}
        </CardBody>
      </Card>
    </Fragment>
  );
};

export default AddEditSiteDetails;
